import { plog } from '../../../shared/utils/plog';

const RALPH_API_BASE_URL = process.env.REACT_APP_RALPH_API_BASE_URL;
plog('Client API base URL: ', RALPH_API_BASE_URL);

export default RALPH_API_BASE_URL;
